import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import less from 'less'

import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import echarts from 'echarts'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueCookies from 'vue-cookies'
import './assets/thirdicon/iconfont.css'

import { isTimedOut, getLastTime, myDateFormat } from "@/api/common";

Vue.use(VueAxios, axios)
Vue.use(ElementUI)
Vue.use(VueCookies)
Vue.use(Vuex)
Vue.use(less)

Vue.config.productionTip = false
Vue.prototype.bus = new Vue()
Vue.prototype.$echarts = echarts

Vue.prototype.isTimedOut = isTimedOut
Vue.prototype.getLastTime = getLastTime
Vue.prototype.myDateFormat = myDateFormat



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
